import { render, staticRenderFns } from "./AdmissionAccountEmail.vue?vue&type=template&id=6c5f2402&scoped=true&"
import script from "./AdmissionAccountEmail.vue?vue&type=script&lang=ts&"
export * from "./AdmissionAccountEmail.vue?vue&type=script&lang=ts&"
import style0 from "./AdmissionAccountEmail.vue?vue&type=style&index=0&id=6c5f2402&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5f2402",
  null
  
)

export default component.exports